<template>
  <v-container>
    <v-row class="margin-center">
        <form class="mt-5 col-12" >
              <v-col cols="12" sm="6" md="12" class="p-none">
                <div id="recaptcha-container"></div>
              </v-col>
            <div id="one">
              <v-col cols="8" sm="8" md="12" class="check-circle plr-none d-flex flex-column align-center justify-center text-center mb-10">
                <h2>Unesite svoj broj mobilnog telefona</h2>
                <p>i stići će vam SMS poruka sa verifikacionim kodom</p>
              </v-col>
              <v-col cols="12" sm="6" md="10" class="plr-none d-flex flex-row">

             <div class="v-input__slot">
               <div class="v-text-field__slot">  

                 <vue-tel-input class="mr-2"
                  label="Mobilni Telefon"
                  filled
           
                  v-model="phone"
   
                  v-bind="bindProps" v-on:country-changed="countryChanged"
                ></vue-tel-input>
               </div>
               </div>
              </v-col>
            
              <v-form  v-model="isFormValid">
                <v-col cols="12" sm="6" md="10" class="plr-none d-flex flex-row">
                 <v-checkbox v-model="checkbox" class="mr-4"  :rules="[v => !!v || 'Morate prihvatiti pravila korišćenja da biste nastavili!']">
                  <template v-slot:label>
                    <div>
                      Slažem se sa 
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            target="_blank"
                            href="/uslovi"
                            @click.stop
                            v-on="on"
                          >
                          uslovima korišćenja
                          </a>
                        </template>
                          Pogledajte uslove korišćenja u novom prozoru
                      </v-tooltip>
                      .
                    </div>
                  </template>
                </v-checkbox>
                 <v-checkbox v-model="checkbox2"   :rules="[v => !!v || 'Morate prihvatiti pravila korišćenja da biste nastavili!']">
                  <template v-slot:label>
                       Saglasan sam da dobijam obaveštenja putem SMS-a i email-a.
                  </template>
                </v-checkbox>
                </v-col>
              </v-form>

              <v-col cols="12" sm="6" md="10" class="p-none">
                <v-btn  :disabled="!isFormValid"  id="sign-in-button"  class="mr-4 ml-4" width="-webkit-fill-available" height="50" rounded color="primary" dark @click="phoneAuth">POŠALJI KOD</v-btn>
              </v-col>
            </div>
            
            <div id="two" style="display:none">
              <v-col cols="8" sm="8" md="12" class="check-circle plr-none d-flex flex-column align-center justify-center text-center mb-10">
                  <v-img
                    :src="require('../assets/Icon-Check-Circle.svg')"
                    class="mb-6 mt-4"
                  />
                <h2>Poslat je sms na broj</h2>
                <p class="mb-5">{{phone}}</p>
                <p class="mb-5">Molimo unesite verifikacioni kod</p>
              </v-col>
              <v-col cols="12" sm="6" md="12" class="p-none">
                <v-text-field
                  id="verificationCode"
                  label="Verifikacioni broj"
                  filled
                  placeholder="000000"
                  v-model="verify"
                  required
                ></v-text-field>
                <v-btn  class="mr-4 ml-4" width="-webkit-fill-available" height="50" rounded color="primary" dark @click="codeVerify">POTVRDI</v-btn>
              </v-col>
            </div>
        </form>
    </v-row>
  </v-container>
</template>

<script>
  import firebase from 'firebase'
  import {fb , db} from '../main'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'Registration',
    mixins: [validationMixin],

    validations: {
      checkbox: { required },
      checkbox2: { required },
      phone: {required},
    },

    data: () => ({
  
      isFormValid: false,
      checkbox: false,
      checkbox2: false,
      phone: null,
      country: null,
        bindProps: {
        defaultCountry: "RS",
        disabledFetchingCountry: false,
        disabled: false,
        disabledFormatting: false,
        placeholder: "Enter a phone number",
        required: false,
        enabledCountryCode: false,
        enabledFlags: true,
        onlyCountries: ["RS"],
        maxLen:15,
        inputOptions: {
          showDialCode: true
        }
        }
    }),

    countryChanged(country) {
     this.country = '+' + country.dialCode
    },
    
    methods: {
phoneAuth() {
  firebase.auth().languageCode = 'sr';
  if (!window.recaptchaVerifier) {
window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
  size: 'invisible',
});
    window.recaptchaVerifier.render();
  }
  const phoneNumber = this.phone;
  const appVerifier = window.recaptchaVerifier;

  firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
    .then(function (confirmationResult) {
      window.confirmationResult = confirmationResult;
    })
    .catch(err => {
      alert(err.message);
      if (document.getElementById('two')) {
        window.location.reload();
        if (document.getElementById('two').style.display == 'none') {
          document.getElementById('one').style.display = 'none';
          document.getElementById('two').style.display = 'block';
        } else {
          document.getElementById('one').style.display = 'block';
          document.getElementById('two').style.display = 'none';
        }
      }
    });

  if (document.getElementById('one')) {
    if (document.getElementById('one').style.display == 'none') {
      document.getElementById('one').style.display = 'block';
      document.getElementById('two').style.display = 'none';
    } else {
      document.getElementById('one').style.display = 'none';
      document.getElementById('two').style.display = 'block';
    }
  }
  
},
  

      codeVerify() {

        var code = this.verify
        confirmationResult.confirm(code)
  
        .then( user => {
          var phonenum = this.phone
          var accountRef = db.collection("accounts").doc(user.user.uid)
              var setWithMerge = accountRef.set({
                  phone:phonenum
              }, { merge: true })
           firebase.auth().onAuthStateChanged(function(user) {
            var db = firebase.firestore();
              if (user) {
           var accountRef = db.collection("accounts").doc(user.uid)
           var setWithMerge = accountRef.set({
              phone:phonenum
          }, { merge: true })
           
            .catch(function(error) {
              console.log("Got an error: ",error);
              });
            } else {
              // No user is signed in.
            }
            })
    
              this.$router.push('/info') 

            .catch(function(error) {
                console.error("Greška: ", error)
            })

     
          },
          err => {
            alert(err.message)
          }) 
          
      },
      
      
    },
    
    
  }

</script>

<style>
.v-text-field__slot {
  width: 100%;
}
.vue-tel-input{
  background: rgba(0, 0, 0, 0.06);
  border: none!important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42)!important;
  border-radius:1px!important
}
.vue-tel-input input{
  border-top: none;
  background: rgba(0, 0, 0, 0.06);
  line-height: 20px;
    padding: 16px 16px 8px;
}
.vue-tel-input input:focus {
     outline: none!important;
}
.vue-tel-input:focus-within {
    outline: none!important;
    box-shadow: none!important;
    border-bottom: 2px solid #5E6A71!important;
    border-color: #5E6A71!important;
}
.vti__dropdown:focus {
  outline: none!important;
}
.plr-none{
    padding:0 10px!important;
    margin: 0 auto!important;
}
.p-none{
    margin: 0 auto!important;
}
.check-circle {
      margin: 0 auto;
}
</style>